import { render, staticRenderFns } from "./openClass.vue?vue&type=template&id=65039559&scoped=true"
import script from "./openClass.vue?vue&type=script&lang=js"
export * from "./openClass.vue?vue&type=script&lang=js"
import style0 from "./openClass.vue?vue&type=style&index=0&id=65039559&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65039559",
  null
  
)

export default component.exports